import * as d3 from 'd3';
import React from 'react';

import { WebinarPlayerContext } from '$/components/WebinarPlayer/context';

import { ZoomScaleProviderContext } from './ZoomScaleProviderContext';

export const TranslateScrollbar: React.FC = () => {
  const { zoom, zoomRef, zoomTransform } = React.useContext(ZoomScaleProviderContext);
  const { colors, timelineComponents } = React.useContext(WebinarPlayerContext);
  const [cursor] = React.useState('grab');

  const width = zoomTransform
    ? Math.max(0, zoom!.translateExtent()[1][0] / zoomTransform.k)
    : zoom!.translateExtent()[1][0];

  let x = zoomTransform ? (zoomTransform.x / zoomTransform.k) * -1 : 0;
  x = x > 0 ? (x > zoom!.translateExtent()[1][0] ? zoom!.translateExtent()[1][0] - width : x) : 0;

  const refTrack = React.useCallback(
    (dom: Element | null) => {
      if (!dom || !zoomRef?.current) return;
      const root = d3.select(dom);

      const drag = d3
        .drag()
        .on('start', () => {})
        .on('drag', (event) => {
          const newX = event.x;

          // x && zoom && zoom!.translateTo && d3.select(zoomRef!.current).call(zoom!.translateTo, x);
          const zoomRoot = d3.select(zoomRef.current);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          zoomRoot && zoomRoot.call(zoom!.translateTo as any, newX);
        })
        .on('end', () => {});

      root.call(drag);
    },
    [zoom, zoomRef]
  );

  /*const refThumb = useD3(
    (root) => {
      let startX = 0;

      const drag = d3
        .drag()
        .on('start', () => {
          setCursor('grabbing');
          startX = d3.event.x;
        })
        .on('drag', () => {
          const delta = d3.event.x - startX;
          const newX = x + delta;
          console.log('x ', x, ' ', newX);

          // x && zoom && zoom!.translateTo && d3.select(zoomRef!.current).call(zoom!.translateTo, x);
          const zoomRoot = d3.select(zoomRef!.current);
          zoomRef! && zoomRoot && zoomRoot.call(zoom!.translateTo as any, newX);
        })
        .on('end', (_: any) => {
          setCursor('grab');
        });

      root.call(drag);
    },
    [zoomRef, zoom]
  );*/

  return (
    <g className='translateSlider'>
      <rect
        ref={refTrack}
        x={10}
        y={timelineComponents.scroll.offset}
        width={Math.max(zoom!.translateExtent()[1][0] - 20, 0)}
        height={timelineComponents.scroll.height}
        cursor={'pointer'}
        rx={5}
        fill={colors.sliderBg}
      />
      <rect
        style={{
          transition:
            zoomTransform && zoomTransform!.k === zoom!.scaleExtent()[0]
              ? 'opacity 0.05s all'
              : 'opacity 0.05s linear',
          opacity: zoomTransform && zoomTransform!.k !== zoom!.scaleExtent()[0] ? 1 : 0,
        }}
        ref={refTrack}
        x={x + 10}
        y={timelineComponents.scroll.offset}
        width={Math.max(width - 20, 10)}
        height={timelineComponents.scroll.height}
        rx={5}
        cursor={cursor}
        fill={colors.sliderTrackBg}
      />
    </g>
  );
};
